import React, { useState } from "react";
import { Card, Input, Button, Typography, message } from "antd";
import axios from "axios";
import yogaImg from "../../assets/yoga.jpg";
import { BASE_URL } from "../../Config";
import SuccessPopup from "../../Components/popup/SuccessPopup";
import ErrorPopup from "../../Components/popup/ErrorPopup";

const { Title, Text } = Typography;
export const styles = {

    container: {

        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#64b56a",

    },

    card: {

        width: "fit-content",
        borderRadius: "15px",
        overflow: "hidden",

        display: "flex",

    },

    left: {

        maxWidth: "450px",
        padding: "20px",

    },

    right: {

        maxWidth: "450px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",

    },

    image: {

        width: "100%",

    },

    input: {

        marginTop: "20px",
        height: "40px",

    },

    button: {

        marginTop: "20px",
        height: "45px",
        backgroundColor: "#64b56a",
        color: "#fff",
        fontWeight: "bold",
        border: "none",

    },

};
const ForgotPassword = () => {

    const [successPopup, setSuccessPopup] = useState(false);
    const [errorPopup, setErrorPopup] = useState(false);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const handleSubmit = async () => {

        try {

            setLoading(true);

            const res = await axios.post(
                `${BASE_URL}/auth/forgot-password`,
                { email }
            );

            message.success(res?.data?.message);
            setSuccessPopup(true)
        } catch (err) {

            const msg = err.response?.data?.message || "Something went wrong";

            setErrorMessage(msg);

            setErrorPopup(true);

        } finally {

            setLoading(false);

        }

    };

    return (

        <div style={styles.container}>

            <Card style={styles.card} bodyStyle={{ padding: 0 }}>

                <div style={styles.left}>

                    <img src={yogaImg} style={styles.image} />

                </div>

                <div style={styles.right}>

                    <Title level={3}>Forgot Password</Title>

                    <Text type="secondary">
                        Enter your email to receive reset link
                    </Text>

                    <Input
                        placeholder="Type your Email"
                        style={styles.input}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <Button
                        style={styles.button}
                        loading={loading}
                        onClick={handleSubmit}
                        disabled={!email}
                        block
                    >
                        SEND RESET LINK
                    </Button>

                </div>

            </Card>
            <SuccessPopup
                open={successPopup}
                onClose={() => setSuccessPopup(false)}
                message="Reset link sent successfully"
            />

            <ErrorPopup
                open={errorPopup}
                onClose={() => setErrorPopup(false)}
                message={errorMessage}
            />
        </div>

    );

};

export default ForgotPassword;
